// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PssS8c_15tJqMC {
  width: 100%;
}
.F_8WMnF47ov7Gl {
  display: flex;
  width: 170px;
  height: 120px;
  margin: var(--ds-space-300, 24px) auto;
}
.erVxiKLxuLsjo5 {
  margin: var(--ds-space-100, 8px) auto;
  text-align: center;
}
.p7XPJpQ_JVJ6s6 {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.OEW8pRktyPjnOo {
  display: flex;
  gap: var(--ds-space-100, 8px);
  flex-wrap: wrap;
}
`, ""]);
// Exports
export var container = `PssS8c_15tJqMC`;
export var modalImage = `F_8WMnF47ov7Gl`;
export var modalTitle = `erVxiKLxuLsjo5`;
export var modalText = `p7XPJpQ_JVJ6s6`;
export var buttonContainer = `OEW8pRktyPjnOo`;
export default ___CSS_LOADER_EXPORT___;
